/**
 * @desc 红人管理-导出KOL
 */
const URL = "/rantion-kol";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.kol.celebrity.exportExcel.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/kol/celebrity/exportExcel`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
